<template>
  <v-card>
    <div>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon size="32px">notifications_active</v-icon>
          {{ organizationName }} Alerts
        </v-toolbar-title>
        <v-spacer/>
        
        <v-btn
          text
          small
          class="ma-1"
          @click="$router.push('/alerts/templates')"
        >
          <v-icon>settings</v-icon> Alert Settings
        </v-btn>
        
        <v-btn
          text
          small
          class="ma-1"
          @click="$router.push('/alerts/config')"
        >
          <v-icon>history</v-icon> Legacy Alert Settings
        </v-btn>
      </v-toolbar>
      <v-divider/>
    </div>
    <v-card-text>
      <v-alert dense outlined type="error" v-if="error">
        {{ errorText }}
      </v-alert>
      
      <v-card flat class="mb-5">
        <v-card-title>
          Current Alerts
        </v-card-title>
        <v-card-text>
          <v-alert dense outlined type="error" v-if="alertsError">
            {{ alertsErrorText }}
          </v-alert>
          
          <v-data-table
            :headers="headers"
            :items="$alerts.alerts"
            :loading="!$alerts.ready"
            loadingText="Loading alerts..."
            no-data-text="No alerts"
            sort-by="timestamp"
            :sort-desc="true"
            :items-per-page="200"
            hide-default-footer
          >
            <template v-slot:item.label="{ item }">
              <span class="subtitle-2">{{ item.label }}</span>
            </template>
            <template v-slot:item.resolved="{ item }">
              <alert-state-label :alert="item" />
            </template>
            <template v-slot:item.device_guid="{ item }">
              <device-label :device="$devices.getDevice(item.device_guid)" />
            </template>
            <template v-slot:item.timestamp="{ item }">
              {{ item.timestamp | moment("YYYY/MM/DD hh:mm:ss a") }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <device-events v-if="organization && organization.org_guid" heading="Recent Device Alerts" :showDevice="true" targetObject="orgs" :targetGUID="organization.org_guid" :startTime="eventStartTime" eventType="device_alert"/>
      <device-events v-if="organization && organization.org_guid" heading="Recent Legacy Alerts" :showDevice="true" targetObject="orgs" :targetGUID="organization.org_guid" :startTime="eventStartTime" eventType="alert"/>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DeviceEvents from '../device/components/DeviceEvents.vue'
  
  import moment from 'moment'
  
  export default {
    name: 'AlertListing',
    components: {
      DeviceEvents
    },
    data() {
      return {
        error: false,
        errorText: '',
        
        headers: [
          { text: 'Device', align: 'start text-no-wrap', value: 'device_guid', sortable: false },
          { text: 'Alert', align: 'start', value: 'label', sortable: true, width: '25%' },
          { text: 'Created', align: 'start', value: 'timestamp', sortable: false },
          { text: 'State', align: 'start', value: 'resolved', sortable: false},
        ],
        
        itemsPerPage: 50,
        
        selectedAlert: false,
        
        eventStartTime: moment().subtract('5', 'days').toISOString(),
      }
    },
    computed: {
      ...mapGetters('user', ['organization']),
      
      alertsError() {
        return this.$alerts.error
      },
      alertsErrorText() {
        return this.$alerts.errorText
      },
      
      organizationName() {
        if (this.organization) {
          return (this.organization.org_name) ? this.organization.org_name : this.organization.org_guid
        }
        return 'No Organization'
      },
      
      loading() {
        console.log('loading', this.$alerts.ready)
        return !this.$alerts.ready
      },
      
      alerts() {
        return this.$alerts.alerts
      },
    },
  }
</script>